import { initializePostMessageToFrameCallback, postUpdatePromptInputDataMessage, } from "owa-bizchat-shared/lib/utils/PostMessageToFrameHandler";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type { MailboxInfo } from "owa-client-types";
import { onBizChatReady } from "../actions/onBizChatReady";

interface ChatReadyPayload {
    // if undefined, it means CSR
    renderMode?: "SSR";
}

/**
 * Core handler for chat ready - initializes messaging infrastructure
 * This is part of the core messaging service, not context-specific
 */
export async function chatReady(payload: ChatReadyPayload, postMessageToFrame: (message: unknown) => void, mailboxInfo: MailboxInfo | undefined, targetWindow: Window | undefined, isImmersiveBizchat?: boolean): Promise<void> {
    if (!mailboxInfo || !targetWindow) {
        return;
    }
    onBizChatReady(payload.renderMode ?? "CSR", targetWindow, isImmersiveBizchat);
    
    handleChatSetup(postMessageToFrame, mailboxInfo, targetWindow, isImmersiveBizchat);
}

export async function appLoadedFromCache(_payload: any, postMessageToFrame: (message: unknown) => void, mailboxInfo: MailboxInfo | undefined, targetWindow: Window | undefined, isImmersiveBizchat?: boolean): Promise<void> {
    if (!mailboxInfo || !targetWindow) {
        return;
    }
    
    handleChatSetup(postMessageToFrame, mailboxInfo, targetWindow, isImmersiveBizchat);
}

function handleChatSetup(postMessageToFrame: (message: unknown) => void, mailboxInfo: MailboxInfo, targetWindow: Window, isImmersiveBizchat?: boolean) {
    initializePostMessageToFrameCallback(postMessageToFrame, mailboxInfo, targetWindow, isImmersiveBizchat);
    
    if (!isGlobalFeatureEnabled("mon-copilot-bizchat-minimalux")) {
        // If minimal UX is not enabled, we need to send the prompt input data message after chatReady on boot.
        // If minimal UX is enabled, prompt input data is passed in subPageId on bizchat boot.
        postUpdatePromptInputDataMessage(mailboxInfo, targetWindow, isImmersiveBizchat);
    }
}
